import { hasLoggedInCookie, mockApi, mockApiHubInfo, mockApiProfile, mockApiPrices, apiGetHubInfo, urlApiPrices, urlApiProfile, } from "../api.js";
import { dateFormatter, getJson } from "../util.js";
import { createHub } from "./hub_creation.js";
const SPINNER_FRAMES = ["⠋", "⠙", "⠹", "⠸", "⠼", "⠴", "⠦", "⠧", "⠇", "⠏"];
const rubFormatter = new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    // @ts-ignore
    trailingZeroDisplay: "stripIfInteger",
});
const pricingIntegerFormatter = new Intl.NumberFormat("ru-RU");
const pricingFractionFormatter = new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
const PRICING_COLUMNS = [
    { key: "input_tokens", label: "Вход", width: 10 },
    { key: "output_tokens", label: "Выход", width: 10 },
    { key: "cache_read_tokens", label: "Кэш чтение", width: 10 },
    { key: "cache_5m_write_tokens", label: "Кэш запись", width: 10 },
];
const PRICING_COLUMNS_MOBILE = [
    { key: "input_tokens", label: "Вход", width: 8 },
    { key: "output_tokens", label: "Выход", width: 8 },
];
const VIEWPORT_INSET_PX = 10;
const isMobileLayout = () => window.innerWidth < 640;
const getInset = () => (isMobileLayout() ? 0 : VIEWPORT_INSET_PX);
const getTerminalRadius = () => (isMobileLayout() ? "0" : "18px");
const OFFER_TEXT = `ПУБЛИЧНАЯ ОФЕРТА
о предоставлении доступа к сервису CoreInfra AI Hub

Редакция от «11» февраля 2026 г.

Настоящий документ является публичной офертой в соответствии со ст. 437 Гражданского кодекса Российской Федерации и адресован:

юридическим лицам;
индивидуальным предпринимателям;
физическим лицам, обладающим полной дееспособностью.
Акцептом настоящей оферты является внесение Пользователем денежных средств на Баланс в Сервисе.
С момента зачисления средств договор считается заключенным.

1. Термины и определения
Сервис — программно-аппаратный комплекс CoreInfra, размещенный на доменах coreinfra.ru и coreinfra.ai, предоставляющий доступ к Личному кабинету и моделям искусственного интеллекта в соответствии с Прайсом.

Оператор — лицо, размещающее настоящую оферту и предоставляющее доступ к Сервису на доменах coreinfra.ru и coreinfra.ai.

Пользователь — юридическое лицо, индивидуальный предприниматель или физическое лицо, принявшее настоящую оферту.

Личный кабинет — персональный раздел Пользователя в Сервисе, предназначенный для управления Балансом, автопополнением, доступом к моделям и просмотра истории операций.

Баланс — учетная запись в Личном кабинете, отражающая внесенные Пользователем денежные средства.

Модели — программные модели искусственного интеллекта, доступ к которым предоставляется через Сервис. Перечень и стоимость использования моделей указаны в Прайсе.

Прайс — размещенный на сайте перечень доступных моделей, тарифов и правил расчета стоимости услуг.

2. Предмет договора
2.1. Оператор предоставляет Пользователю доступ к Сервису и Моделям в пределах оплаченного Баланса.

2.2. Перечень Моделей и стоимость их использования определяются Прайсом, действующим на момент использования.

2.3. Списание средств производится по факту потребления ресурсов в соответствии с Прайсом.

3. Доступ к сервису
3.1. При создании Личного кабинета Сервис формирует уникальную логин‑ссылку доступа.

3.2. Указанная логин‑ссылка отображается Пользователю в Личном кабинете при его создании.

3.3. Пользователь обязан самостоятельно сохранить логин‑ссылку и обеспечить ее конфиденциальность.

3.4. Доступ к Личному кабинету осуществляется посредством перехода по логин‑ссылке. Использование логина и пароля не применяется.

3.5. Оператор не несет ответственности за утрату доступа в случае утраты Пользователем логин‑ссылки или передачи ее третьим лицам.

3.6. Оператор вправе внедрять дополнительные механизмы подтверждения доступа при необходимости.

4. Баланс и расчеты
4.1. Пользователь пополняет Баланс любым доступным способом, указанным в Личном кабинете.

4.2. Средства, внесенные на Баланс, являются авансом за услуги Сервиса.

4.3. Средства на Балансе не сгорают и учитываются до их полного использования.

4.4. Пользователь самостоятельно контролирует состояние Баланса.

5. Автопополнение
5.1. Пользователь вправе подключить функцию автоматического пополнения Баланса.

5.2. При активации автопополнения Пользователь дает согласие на автоматическое списание денежных средств при достижении установленного минимального порога Баланса.

5.3. Размер порога и сумма пополнения определяются Пользователем в Личном кабинете.

5.4. Пользователь вправе отключить автопополнение в любой момент.

5.5. Оператор не несет ответственности за отказ платежной системы или банка в проведении автоматического списания.

6. Использование сервиса
6.1. Пользователь обязуется использовать Сервис исключительно в законных целях.

6.2. Пользователь обязуется соблюдать правила и ограничения использования Моделей, указанные в Прайсе и технической документации.

6.3. Оператор вправе приостановить доступ к Сервису при выявлении нарушений.

7. Ответственность
7.1. Сервис предоставляется «как есть».

7.2. Оператор не гарантирует непрерывную и безошибочную работу Сервиса.

7.3. Оператор не несет ответственности за:

результаты работы Моделей;
действия Пользователя на основе полученных результатов;
перебои в работе, вызванные третьими лицами или техническими причинами.
7.4. Ответственность Оператора ограничивается суммой денежных средств, находившихся на Балансе Пользователя на момент возникновения спорной ситуации.

8. Изменение условий
8.1. Оператор вправе изменять настоящую оферту и Прайс.

8.2. Новая редакция вступает в силу с момента публикации на доменах coreinfra.ru или coreinfra.ai.

8.3. Продолжение использования Сервиса означает согласие Пользователя с обновленными условиями.

9. Персональные данные
9.1. Обработка персональных данных осуществляется в соответствии с Политикой конфиденциальности, размещенной на сайте.

9.2. Пользователь соглашается на передачу данных третьим лицам в объеме, необходимом для оказания услуг.

10. Реквизиты Оператора
Полное наименование: Общество с ограниченной ответственностью «КОР ИНФРА»

Сокращенное наименование: ООО «КОР ИНФРА»

Юридический адрес: 199178, г. Санкт‑Петербург, Васильевский муниципальный округ, 5‑я линия В.О., дом 70 литера А, помещение 11НС

ОГРН: 1257800052377

ИНН: 7801742590

КПП: 780101001

Основной код ОКВЭД: 62.01 – Разработка компьютерного программного обеспечения

Коды видов деятельности в области IT: 1.01, 1.06, 2.01, 10.01

Email для связи: support@coreinfra.ru

Дата публикации: 11.02.2026`;
export function bindKeysForVimCommands(options = {}) {
    const commandPrefix = document.getElementById("less-command-prefix");
    const commandValue = document.getElementById("less-command-value");
    const commandLine = document.querySelector(".less-command-line");
    const statusBar = document.querySelector(".less-status-bar");
    const resultWindow = document.getElementById("less-command-result");
    const resultOverlay = document.getElementById("less-command-overlay");
    const topBar = document.getElementById("manual-top-bar");
    const manualContent = document.getElementById("manual-content");
    const resultTitle = document.getElementById("less-command-result-title");
    const resultBody = document.getElementById("less-command-result-body");
    let commandBuffer = "";
    let commandPrefixFlashTimeout = null;
    const isActive = () => document.body.classList.contains("command-mode");
    const isResultVisible = () => resultWindow !== null && resultWindow.style.display !== "none";
    const syncChrome = () => {
        const active = isActive();
        const resultVisible = isResultVisible();
        const topOffset = topBar?.offsetHeight ?? 0;
        if (commandLine) {
            commandLine.style.display = active ? "flex" : "none";
        }
        const commandLineOffset = active ? (commandLine?.offsetHeight ?? 0) : 0;
        const resultHeightPx = resultVisible
            ? (resultWindow?.offsetHeight ?? 0)
            : 0;
        const inset = getInset();
        const termRadius = getTerminalRadius();
        if (statusBar) {
            statusBar.style.display = resultVisible ? "none" : "flex";
            statusBar.style.bottom = resultVisible
                ? `${resultHeightPx + commandLineOffset + inset}px`
                : active
                    ? `${commandLineOffset + inset}px`
                    : `${inset}px`;
            statusBar.style.background = resultVisible ? "#756741" : "#C8A050";
            statusBar.style.color = resultVisible ? "#26231A" : "#0F0F0D";
            statusBar.style.filter = resultVisible ? "saturate(0.6)" : "";
            statusBar.style.pointerEvents = resultVisible ? "none" : "";
            statusBar.style.borderBottomLeftRadius =
                active || resultVisible ? "0" : termRadius;
            statusBar.style.borderBottomRightRadius =
                active || resultVisible ? "0" : termRadius;
        }
        if (commandLine) {
            commandLine.style.borderBottomLeftRadius = active ? termRadius : "0";
            commandLine.style.borderBottomRightRadius = active ? termRadius : "0";
        }
        if (resultWindow) {
            resultWindow.style.top = "auto";
            resultWindow.style.bottom = `${commandLineOffset + inset}px`;
            resultWindow.style.maxHeight = `${Math.max(window.innerHeight - topOffset - commandLineOffset - inset * 2, 0)}px`;
        }
        if (resultOverlay) {
            resultOverlay.style.top = `${topOffset + inset}px`;
        }
    };
    const syncCommandValue = () => {
        if (commandValue) {
            commandValue.textContent = commandBuffer;
        }
    };
    const flashCommandPrefix = () => {
        if (!(commandPrefix instanceof HTMLElement)) {
            return;
        }
        if (commandPrefixFlashTimeout !== null) {
            window.clearTimeout(commandPrefixFlashTimeout);
        }
        commandPrefix.style.color = "#FFFFFF";
        commandPrefix.style.fontWeight = "700";
        commandPrefixFlashTimeout = window.setTimeout(() => {
            commandPrefix.style.color = "#C8A050";
            commandPrefix.style.fontWeight = "";
            commandPrefixFlashTimeout = null;
        }, 300);
    };
    const showResult = (title, body, _kind = "INFO", layout = "nowrap") => {
        if (!resultWindow || !resultTitle || !resultBody) {
            return;
        }
        resultTitle.textContent = title.toUpperCase();
        resultBody.replaceChildren(document.createTextNode(body));
        resultBody.dataset["layout"] = layout;
        resultBody.style.whiteSpace = layout === "wrapped" ? "pre-wrap" : "pre";
        resultBody.style.wordBreak = layout === "wrapped" ? "break-word" : "normal";
        resultBody.style.overflowWrap =
            layout === "wrapped" ? "anywhere" : "normal";
        resultBody.style.overflowX = "auto";
        resultBody.style.overflowY = "auto";
        if (resultOverlay) {
            resultOverlay.style.display = "block";
        }
        if (manualContent) {
            manualContent.style.pointerEvents = "none";
        }
        document.body.classList.add("command-result-open");
        document.body.style.overflow = "hidden";
        resultWindow.style.display = "flex";
        syncChrome();
    };
    const showResultNodes = (title, nodes, _kind = "INFO", layout = "nowrap") => {
        if (!resultWindow || !resultTitle || !resultBody) {
            return;
        }
        resultTitle.textContent = title.toUpperCase();
        resultBody.replaceChildren(...nodes);
        resultBody.dataset["layout"] = layout;
        resultBody.style.whiteSpace = layout === "wrapped" ? "pre-wrap" : "pre";
        resultBody.style.wordBreak = layout === "wrapped" ? "break-word" : "normal";
        resultBody.style.overflowWrap =
            layout === "wrapped" ? "anywhere" : "normal";
        resultBody.style.overflowX = "auto";
        resultBody.style.overflowY = "auto";
        if (resultOverlay) {
            resultOverlay.style.display = "block";
        }
        if (manualContent) {
            manualContent.style.pointerEvents = "none";
        }
        document.body.classList.add("command-result-open");
        document.body.style.overflow = "hidden";
        resultWindow.style.display = "flex";
        syncChrome();
    };
    const renderBoldHeadingLines = (body, boldLines) => {
        const nodes = [];
        const boldLineSet = new Set(boldLines);
        const lines = body.split("\n");
        lines.forEach((line, index) => {
            if (boldLineSet.has(line)) {
                const strong = document.createElement("span");
                strong.style.fontWeight = "700";
                strong.textContent = line;
                nodes.push(strong);
            }
            else {
                nodes.push(document.createTextNode(line));
            }
            if (index < lines.length - 1) {
                nodes.push(document.createTextNode("\n"));
            }
        });
        return nodes;
    };
    const hideResult = () => {
        if (!resultWindow) {
            return;
        }
        resultWindow.style.display = "none";
        if (resultBody) {
            resultBody.dataset["layout"] = "nowrap";
            resultBody.style.whiteSpace = "pre";
            resultBody.style.wordBreak = "normal";
            resultBody.style.overflowWrap = "normal";
            resultBody.style.overflowX = "auto";
            resultBody.style.overflowY = "auto";
        }
        if (resultOverlay) {
            resultOverlay.style.display = "none";
        }
        if (manualContent) {
            manualContent.style.pointerEvents = "";
        }
        document.body.classList.remove("command-result-open");
        document.body.style.overflow = "";
        syncChrome();
    };
    const onOverlayWheel = (event) => {
        if (!isResultVisible() || !resultBody) {
            return;
        }
        event.preventDefault();
        resultBody.scrollBy({ top: event.deltaY });
    };
    resultOverlay?.addEventListener("wheel", onOverlayWheel, { passive: false });
    const onPointerDown = (event) => {
        const target = event.target;
        if (!(target instanceof Node)) {
            return;
        }
        if (!isActive() && !isResultVisible()) {
            return;
        }
        if (commandLine?.contains(target) || resultWindow?.contains(target)) {
            return;
        }
        hideResult();
        close();
    };
    window.addEventListener("resize", syncChrome);
    syncChrome();
    document.addEventListener("pointerdown", onPointerDown);
    const open = () => {
        commandBuffer = "";
        syncCommandValue();
        document.body.classList.add("command-mode");
        syncChrome();
    };
    const close = () => {
        commandBuffer = "";
        syncCommandValue();
        document.body.classList.remove("command-mode");
        syncChrome();
    };
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        section?.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const activateAgentTab = (agentId) => {
        const tab = document.querySelector(`[data-agent-tab="${agentId}"]`);
        tab?.click();
        scrollToSection("setup-agent");
    };
    const navigateTo = (href) => {
        hideResult();
        close();
        window.setTimeout(() => {
            window.location.assign(href);
        }, 0);
    };
    const loadProfile = async () => {
        return mockApi ? mockApiProfile : getJson(urlApiProfile);
    };
    const loadHubInfo = async (hubId) => {
        return mockApi
            ? { ...mockApiHubInfo, hub_id: hubId }
            : apiGetHubInfo(hubId);
    };
    const loadStatusInfo = async () => {
        const profile = await loadProfile();
        const hubInfo = await loadHubInfo(profile.personal_hub_id);
        return { profile, hubInfo };
    };
    const loadCurrentHubInfo = async () => {
        const profile = await loadProfile();
        return loadHubInfo(profile.personal_hub_id);
    };
    const loadPricing = async () => {
        return mockApi
            ? mockApiPrices
            : getJson(`${urlApiPrices}?short-list`);
    };
    const getPrimaryAgentToken = (hubInfo) => hubInfo?.agent_tokens[0]?.token ?? "sk-ci-...";
    const getAgentTokenPreview = (hubInfo) => getPrimaryAgentToken(hubInfo).slice(-20) || "...";
    const hasCreatedHub = () => {
        if (mockApi || hasLoggedInCookie()) {
            return true;
        }
        const hubName = document
            .getElementById("hub-name-link")
            ?.textContent?.trim();
        return Boolean(hubName);
    };
    const formatPriceValue = (key, value) => {
        if (value === undefined) {
            return "—";
        }
        const normalized = key === "web_search_requests" ? value / 1000 : value;
        return Number.isInteger(normalized)
            ? pricingIntegerFormatter.format(normalized)
            : pricingFractionFormatter.format(normalized);
    };
    const padCell = (value, width, align) => {
        if (value.length >= width) {
            return value;
        }
        return align === "right"
            ? value.padStart(width, " ")
            : value.padEnd(width, " ");
    };
    const selectNodeText = (node) => {
        const selection = window.getSelection();
        if (!selection) {
            return;
        }
        const range = document.createRange();
        range.selectNodeContents(node);
        selection.removeAllRanges();
        selection.addRange(range);
    };
    const createStatusLoginLink = (value) => {
        const span = document.createElement("span");
        span.textContent = value;
        span.style.userSelect = "all";
        span.addEventListener("dblclick", () => {
            selectNodeText(span);
            void navigator.clipboard.writeText(value).catch(() => { });
        });
        return span;
    };
    const formatPricingDate = (data) => {
        const updatedAt = data
            ?.updated_at_unix_s;
        if (typeof updatedAt === "number" && Number.isFinite(updatedAt)) {
            return dateFormatter.format(new Date(updatedAt * 1000));
        }
        return dateFormatter.format(new Date());
    };
    const formatPricing = (data) => {
        const providers = Object.entries(data.providers).sort(([a], [b]) => a.localeCompare(b));
        const rows = providers.flatMap(([, provider]) => Object.entries(provider.models)
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([modelId, model]) => ({
            modelLabel: model.display_name ?? modelId,
            prices: model.prices,
        })));
        if (rows.length === 0) {
            return "тарифы не найдены";
        }
        const columns = isMobileLayout() ? PRICING_COLUMNS_MOBILE : PRICING_COLUMNS;
        const modelWidth = Math.max(isMobileLayout() ? 16 : 20, ...rows.map((row) => row.modelLabel.length), "Модель".length);
        const header = [
            padCell("Модель", modelWidth, "left"),
            ...columns.map((column) => padCell(column.label, column.width, "right")),
        ].join("  ");
        const body = rows.map((row) => [
            padCell(row.modelLabel, modelWidth, "left"),
            ...columns.map((column) => padCell(formatPriceValue(column.key, row.prices[column.key]), column.width, "right")),
        ].join("  "));
        return [
            "Цены в ₽ за 1 млн токенов, кроме поиска — за 1 тыс. запросов.",
            `Последнее обновление: ${formatPricingDate(data)}`,
            "",
            header,
            ...body,
        ].join("\n");
    };
    const formatClaudeConfig = (hubInfo) => {
        const apiKey = getPrimaryAgentToken(hubInfo);
        const apiKeyPreview = getAgentTokenPreview(hubInfo);
        return [
            "Установка агента:",
            "",
            "npm install -g @anthropic-ai/claude-code",
            "",
            "Настройка доступа в ~/.claude/settings.json:",
            "",
            "{",
            '  "env": {',
            '    "ANTHROPIC_BASE_URL": "https://hub.coreinfra.ai/anthropic/api",',
            `    "ANTHROPIC_API_KEY": "${apiKey}"`,
            "  }",
            "}",
            "",
            "Выключение лишних нотификаций в ~/.claude.json:",
            "",
            "{",
            '  "hasCompletedOnboarding": true,',
            '  "customApiKeyResponses": {',
            `    "approved": ["${apiKeyPreview}"]`,
            "  }",
            "}",
            "",
            "Проверка подключения:",
            "",
            'claude --print "2 + 2"',
        ].join("\n");
    };
    const formatCodexConfig = (hubInfo) => {
        const apiKey = getPrimaryAgentToken(hubInfo);
        return [
            "Установка агента:",
            "",
            "npm install -g @openai/codex",
            "",
            "Настройка доступа в ~/.codex/config.toml:",
            "",
            'model_provider = "coreinfra"',
            "[model_providers.coreinfra]",
            'name = "CoreInfra AI Hub"',
            'base_url = "https://hub.coreinfra.ai/openai/api/v1"',
            'wire_api = "responses"',
            'env_key = "COREINFRA_API_KEY"',
            "",
            "Добавление API-ключа к хабу в ~/.codex/.env:",
            "",
            `COREINFRA_API_KEY=${apiKey}`,
            "",
            "Проверка подключения:",
            "",
            'codex exec "2 + 2" --skip-git-repo-check',
        ].join("\n");
    };
    const formatOpenCodeConfig = (hubInfo) => {
        const apiKey = getPrimaryAgentToken(hubInfo);
        return [
            "Установка агента:",
            "",
            "npm i -g opencode-ai",
            "",
            "Установка CoreInfra plugin:",
            "",
            "opencode plugin -g '@coreinfra/opencode-plugin@1.2.4'",
            "",
            "Аутентификация в Hub:",
            "",
            "opencode providers login --provider coreinfra",
            "",
            "Токен хаба для входа:",
            "",
            apiKey,
            "",
            "Проверка подключения:",
            "",
            'opencode run -m coreinfra/gpt-5.4-nano "2 + 2"',
            "",
            "Список доступных моделей:",
            "",
            "opencode models coreinfra",
        ].join("\n");
    };
    const formatHelp = () => {
        if (!hasCreatedHub()) {
            return [
                ":help              показать справку",
                ":create-hub        создание нового хаба",
                ":price             показать тарифы",
                ":offer             показать оферту",
                ":q                 выйти из справки",
            ].join("\n");
        }
        return [
            ":help              показать справку",
            ":open-account      перейти в аккаунт хаба",
            ":open-pay          перейти к пополнению счета",
            ":status            показать статус хаба",
            ":price             показать тарифы",
            ":offer             показать оферту",
            ":claude            показать конфигурацию для Claude Code",
            ":codex             показать конфигурацию для Codex",
            ":opencode          показать конфигурацию для OpenCode",
            ":q                 выйти из справки",
        ].join("\n");
    };
    const getStatusData = (statusInfo) => {
        const loggedIn = document.cookie.includes("logged_in=1")
            ? "аутентифицирован"
            : "не аутентифицирован";
        const hubName = statusInfo?.hubInfo.hub_name ||
            document.getElementById("hub-name-link")?.textContent?.trim() ||
            "pending";
        const loginLink = statusInfo?.profile.login_link || "unknown";
        const balance = statusInfo?.hubInfo !== undefined
            ? rubFormatter.format(statusInfo.hubInfo.balance_rub ?? 0)
            : "unknown";
        return {
            hubName: hubName.replace(/^Хаб:\s*/, ""),
            loggedIn,
            loginLink,
            balance,
        };
    };
    const formatStatus = (statusInfo) => {
        if (!hasCreatedHub()) {
            return [
                "Хаб не создан.",
                "",
                "Создайте хаб, чтобы получить персональные ключи, ENV и конфиги.",
            ].join("\n");
        }
        const status = getStatusData(statusInfo);
        return [
            `Имя хаба        ${status.hubName}`,
            `Статус          ${status.loggedIn}`,
            `Логин-ссылка    ${status.loginLink}`,
            `Баланс          ${status.balance}`,
        ].join("\n");
    };
    const renderStatus = (statusInfo) => {
        const status = getStatusData(statusInfo);
        return [
            document.createTextNode(`Имя хаба        ${status.hubName}\n`),
            document.createTextNode(`Статус          ${status.loggedIn}\n`),
            document.createTextNode("Логин-ссылка    "),
            createStatusLoginLink(status.loginLink),
            document.createTextNode(`\nБаланс          ${status.balance}`),
        ];
    };
    const showError = (title, message) => {
        showResult(title, message, "ERROR");
    };
    const runCreateHubCommand = async () => {
        if (hasCreatedHub()) {
            showResult("Create Hub", [
                "Хаб уже создан для текущей сессии.",
                "",
                "Следующая команда:",
                "  :open-account",
            ].join("\n"), "OK");
            return;
        }
        let phase = "Подготовка";
        let spinIdx = 0;
        const renderProgress = () => {
            spinIdx = (spinIdx + 1) % SPINNER_FRAMES.length;
            showResult("Create Hub", [
                `${SPINNER_FRAMES[spinIdx] ?? "⠋"}  ${phase}...`,
                "",
                "Выполняется создание хаба.",
            ].join("\n"), "INFO");
        };
        renderProgress();
        const spinnerInterval = window.setInterval(renderProgress, 80);
        try {
            const hubInfo = await createHub({
                onPhaseChange(nextPhase) {
                    phase = nextPhase;
                },
            });
            window.clearInterval(spinnerInterval);
            showResult("Create Hub", [
                "Хаб успешно создан.",
                "",
                `Имя хаба       ${hubInfo.hub_name || "unknown"}`,
                `Баланс         ${rubFormatter.format(hubInfo.balance_rub ?? 0)}`,
                "",
                "Переход в аккаунт:",
                "  :open-account",
            ].join("\n"), "OK");
        }
        catch (error) {
            window.clearInterval(spinnerInterval);
            const message = error instanceof Error ? error.message : "Не удалось создать хаб.";
            showError("Create Hub Error", message);
        }
    };
    const executeCommand = async (rawCommand) => {
        if (!rawCommand) {
            hideResult();
            return;
        }
        const [name = ""] = rawCommand.split(/\s+/, 1);
        const command = name.toLowerCase();
        switch (command) {
            case "h":
            case "help":
                showResult("Command Help", formatHelp());
                return;
            case "clear":
            case "q":
            case "quit":
                hideResult();
                close();
                return;
            case "status":
                if (!hasCreatedHub()) {
                    showResult("Hub Status", formatStatus(), "OK");
                    return;
                }
                showResult("Hub Status", "Запрашиваю статус хаба...", "INFO");
                try {
                    const statusInfo = await loadStatusInfo();
                    showResultNodes("Hub Status", renderStatus(statusInfo), "OK", "nowrap");
                }
                catch (error) {
                    const message = error instanceof Error
                        ? error.message
                        : "Не удалось загрузить статус хаба.";
                    showError("Hub Status Error", message);
                }
                return;
            case "create-hub":
                await runCreateHubCommand();
                return;
            case "open-pay":
                navigateTo("/payments");
                return;
            case "open-account":
                if (!hasCreatedHub()) {
                    showError("Go To Account", "Хаб еще не создан. Сначала выполните :create-hub.");
                    return;
                }
                navigateTo("/?first-enter");
                return;
            case "price":
                showResult("Price", "Загружаю тарифы...", "INFO");
                try {
                    const pricing = await loadPricing();
                    showResult("Price", formatPricing(pricing), "OK");
                }
                catch (error) {
                    const message = error instanceof Error
                        ? error.message
                        : "Не удалось загрузить тарифы.";
                    showError("Price Error", message);
                }
                return;
            case "offer":
                showResult("Public Offer(7)", OFFER_TEXT, "OK", "wrapped");
                return;
            case "claude":
                if (!hasCreatedHub()) {
                    showError("Claude Config", "Конфигурация Claude Code появится после создания хаба.");
                    return;
                }
                activateAgentTab("claude");
                showResult("Claude Config", "Загружаю конфигурацию...", "INFO");
                try {
                    const hubInfo = await loadCurrentHubInfo();
                    const body = formatClaudeConfig(hubInfo);
                    showResultNodes("Claude Config", renderBoldHeadingLines(body, [
                        "Установка агента:",
                        "Настройка доступа в ~/.claude/settings.json:",
                        "Выключение лишних нотификаций в ~/.claude.json:",
                        "Проверка подключения:",
                    ]), "OK", "nowrap");
                }
                catch (error) {
                    const message = error instanceof Error
                        ? error.message
                        : "Не удалось загрузить конфигурацию Claude Code.";
                    showError("Claude Config Error", message);
                }
                return;
            case "codex":
                if (!hasCreatedHub()) {
                    showError("Codex Config", "Конфигурация Codex появится после создания хаба.");
                    return;
                }
                activateAgentTab("codex");
                showResult("Codex Config", "Загружаю конфигурацию...", "INFO");
                try {
                    const hubInfo = await loadCurrentHubInfo();
                    const body = formatCodexConfig(hubInfo);
                    showResultNodes("Codex Config", renderBoldHeadingLines(body, [
                        "Установка агента:",
                        "Настройка доступа в ~/.codex/config.toml:",
                        "Добавление API-ключа к хабу в ~/.codex/.env:",
                        "Проверка подключения:",
                    ]), "OK", "nowrap");
                }
                catch (error) {
                    const message = error instanceof Error
                        ? error.message
                        : "Не удалось загрузить конфигурацию Codex.";
                    showError("Codex Config Error", message);
                }
                return;
            case "opencode":
                if (!hasCreatedHub()) {
                    showError("OpenCode Config", "Конфигурация OpenCode появится после создания хаба.");
                    return;
                }
                activateAgentTab("opencode");
                showResult("OpenCode Config", "Загружаю конфигурацию...", "INFO");
                try {
                    const hubInfo = await loadCurrentHubInfo();
                    showResultNodes("OpenCode Config", renderBoldHeadingLines(formatOpenCodeConfig(hubInfo), [
                        "Установка агента:",
                        "Установка CoreInfra plugin:",
                        "Аутентификация в Hub:",
                        "Токен хаба для входа:",
                        "Проверка подключения:",
                        "Список доступных моделей:",
                    ]), "OK", "nowrap");
                }
                catch (error) {
                    const message = error instanceof Error
                        ? error.message
                        : "Не удалось загрузить конфигурацию OpenCode.";
                    showError("OpenCode Config Error", message);
                }
                return;
        }
        options.onUnknownCommand?.(rawCommand);
        showError("Unknown Command", `E492: Not an editor command: :${rawCommand}\n\nВведите :help, чтобы посмотреть доступные команды.`);
    };
    const submit = async () => {
        const command = commandBuffer.trim();
        commandBuffer = "";
        syncCommandValue();
        await executeCommand(command);
    };
    const onProgrammaticCommand = (event) => {
        const command = event.detail;
        if (typeof command !== "string" || !command.trim()) {
            return;
        }
        if (!isActive()) {
            open();
        }
        commandBuffer = command.trim();
        syncCommandValue();
        void submit();
    };
    document.addEventListener("hub-for-programmers:run-command", onProgrammaticCommand);
    return {
        handleKeydown(event) {
            if (event.metaKey || event.ctrlKey || event.altKey) {
                return false;
            }
            if (event.key === "Escape" && (isActive() || isResultVisible())) {
                event.preventDefault();
                hideResult();
                close();
                return true;
            }
            if (isActive()) {
                switch (event.key) {
                    case ":":
                        event.preventDefault();
                        if (!commandBuffer) {
                            flashCommandPrefix();
                            return true;
                        }
                        commandBuffer += event.key;
                        syncCommandValue();
                        return true;
                    case "Enter":
                        event.preventDefault();
                        void submit();
                        return true;
                    case "Backspace":
                        event.preventDefault();
                        commandBuffer = commandBuffer.slice(0, -1);
                        syncCommandValue();
                        return true;
                }
                if (event.key.length === 1) {
                    event.preventDefault();
                    commandBuffer += event.key;
                    syncCommandValue();
                    return true;
                }
                event.preventDefault();
                return true;
            }
            if (event.key !== ":") {
                return false;
            }
            event.preventDefault();
            open();
            return true;
        },
    };
}
